import 'react-native-gesture-handler'
import 'react-native-get-random-values'
import 'react-native-url-polyfill/auto'
import { Amplify } from 'aws-amplify'
import { Hub } from 'aws-amplify/utils'
import { fetchAuthSession, signOut, getCurrentUser } from 'aws-amplify/auth'
import NavigationMain from './navigation/stacks/MainNavigation'
import Login from './auth/login'
import { useVerification } from './appBar/context/VerificationContext'
import React, { useEffect, useState, useRef } from 'react'
import { AppState, ActivityIndicator, View, Text, Platform } from 'react-native'
import NetInfo from '@react-native-community/netinfo'
import { DATABASE_CONFIG, deleteAllTables, deleteDatabase, getGlobalVersion, getUser, openDB, updateGlobalVersion } from '../db/indexDB'
import { StorageAdapter } from '../utils/AsyncStorage'
import { VERSION_DATABASE } from '../config/config'
import { useNavigateTabsStore } from '../redux/zustand/navigateTabsStore'
import { useLoaderSaveStores } from '../redux/zustand/loaderSaveStore'
import { ASYNC_STORAGE_KEYS } from './stores/constants/constants.storage'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { deleteZipFolder, eventEmitter, validateConnectionNetwork, getAuthToken } from '../utils/functions.utils'
import SizeCache from '../utils/sizeCache'
import { Image } from 'expo-image'
import { useFooterApp } from '../redux/zustand/footerAppStore'
import { UserServices } from '../../database/user.database'
import { Alert } from 'react-native'
import { useChangeValueLoginStore } from '../redux/zustand/changeValueLoginStore'
import { useSecondarySplashStore } from '../redux/zustand/secondarySplashStore'
import { useAlertsGeneralControllersStore, useAlertTextPS } from '../redux/zustand/alertsGeneralControllersStore'
import SecureStoreWeb from '../utils/SecureStoreWeb'
import { useNavigationPerformance } from './navigation/NavigationPerformanceHelper'
// removed duplicate import of eventEmitter

// Amplify.configure(awsconfig)
//Amplify.Logger.LOG_LEVEL = "DEBUG";

// Variables globales para prevenir remontajes excesivos
let globalIsAuthenticated = false
let globalAuthLoading = true
let globalLastAuthCheck = 0
const AUTH_CHECK_DEBOUNCE = 5000 // 5 segundos
// Umbral de fallos y ventana de gracia para evitar desconexiones agresivas
const AUTH_FAIL_THRESHOLD = 3
const AUTH_FAIL_GRACE_MS = 5 * 60 * 1000 // 5 minutos

const MainAuth = () => <NavigationMain />

const Main = () => {
    // debug suprimido: mount
    // Usar autenticación manual en lugar de withAuthenticator
    const [isAuthenticated, setIsAuthenticated] = useState(globalIsAuthenticated)
    const [authLoading, setAuthLoading] = useState(globalAuthLoading)
    // Contadores de fallos de autenticación (persisten entre renders)
    const authFailureCountRef = useRef(0)
    const lastAuthFailureAtRef = useRef(0)

    // Performance Monitoring - Navigation
    useNavigationPerformance()

    //Logicas de checkUser
    const { isVerificationPending } = useVerification() || { isVerificationPending: true }
    const [viewLoginMain, setViewLogin] = useState(false)
    const setIndexTabStore = useNavigateTabsStore((state) => state.setIndexTab)
    const resetValuesStore = useLoaderSaveStores((state) => state.resetValues)

    const changeValue = useChangeValueLoginStore((state) => state.setValue)
    const setSplashSecondary = useSecondarySplashStore((state) => state.setSplashSecondary)
    const clearSplashSecondary = useSecondarySplashStore((state) => state.clearSplashSecondary)
    // Alert/snackbar global para avisos breves
    const setShowAlertSnackbar = useAlertsGeneralControllersStore((s) => s.setShowAlertSnackbar)
    const { setTextError, setTextSecondary, setTextFinally } = useAlertTextPS.getState()

    // Verificar autenticación de Amplify
    const checkAmplifyAuth = async (opts = { silent: false, background: false }) => {
        const { silent = false, background = false } = opts || {}
        const now = Date.now()
        if (now - globalLastAuthCheck < AUTH_CHECK_DEBOUNCE) {
            // debug suprimido: debounce
            return
        }
        globalLastAuthCheck = now
        try {
            if (!silent) setAuthLoading(true)
            const user = await getCurrentUser()
            // debug suprimido: user authenticated

            // Validar flag local de login (active) para forzar logout si corresponde
            try {
                const db = await openDB(true)
                const localUser = await getUser(db)
                if (localUser && (localUser.login === 0 || localUser.login === false)) {
                // Usuario no autenticado con conectividad: aplicar umbral y mantener navegación si hay usuario local (evitar rebote)
                    try { await UserServices.updateLoginStatus(true) } catch {}
                }
            } catch (e) {
                // debug suprimido: verify local flag
            }

            // Resetear contadores de fallos al autenticar correctamente
            authFailureCountRef.current = 0
            lastAuthFailureAtRef.current = 0
            globalIsAuthenticated = true
            setIsAuthenticated(true)
        } catch (error) {
            // debug suprimido: not authenticated (posible fallo transitorio)
            // Evaluar si hay usuario local para permitir modo offline
            let hasLocalLogin = false
            try {
                const db = await openDB(true)
                const localUser = await getUser(db)
                hasLocalLogin = !!(localUser && localUser.login)
            } catch {}
            try {
                // Intento inmediato de recuperar sesión con credenciales guardadas (una vez por fallo)
                const maybeToken = await getAuthToken('auth_check')
                if (maybeToken) {
                    // Recuperado: considerar autenticado y revalidar en silencio
                    authFailureCountRef.current = 0
                    lastAuthFailureAtRef.current = 0
                    globalIsAuthenticated = true
                    setIsAuthenticated(true)
                    setTimeout(() => checkAmplifyAuth({ silent: true, background: true }), 1000)
                    return
                }
            } catch {}
            // Aplicar umbral y manejar offline con fallback en mobile
            const nowTs = Date.now()
            const timeSinceLastFail = nowTs - (lastAuthFailureAtRef.current || 0)
            if (timeSinceLastFail > AUTH_FAIL_GRACE_MS) {
                authFailureCountRef.current = 0
            }
            authFailureCountRef.current += 1
            lastAuthFailureAtRef.current = nowTs

            // Comprobar conectividad y fallback local (sólo mobile)
            try {
                const net = await NetInfo.fetch()
                const offline = !net.isConnected || !net.isInternetReachable
                if (offline) {
                    if (Platform.OS !== 'web' && hasLocalLogin) {
                        // Mantener navegación offline hasta confirmar inactividad
                        globalIsAuthenticated = true
                        setIsAuthenticated(true)
                        return
                    }
                    // Si offline y sin usuario local, mostrar Login (primer arranque limpio)
                    globalIsAuthenticated = false
                    setIsAuthenticated(false)
                    setViewLogin(true)
                    return
                } else {
                    // Online: si hay usuario local y aún no alcanzamos el umbral, mantener sesión para evitar rebotes
                    if (Platform.OS !== 'web' && hasLocalLogin && authFailureCountRef.current < AUTH_FAIL_THRESHOLD) {
                        globalIsAuthenticated = true
                        setIsAuthenticated(true)
                        // No mostrar Login; reintentar silenciosamente más tarde
                        return
                    }
                }
            } catch {}

            // Si es background/silent, no forzar cambios visibles (evita flicker/reloads)
            if (background || silent) {
                return
            }

            // Usuario no autenticado con conectividad: aplicar umbral y mantener navegación offline si hay usuario local
            if (authFailureCountRef.current >= AUTH_FAIL_THRESHOLD) {
                try {
                    if (Platform.OS !== 'web' && hasLocalLogin) {
                        // Mantener al usuario en la app (modo offline) y avisar; no forzar signOut
                        try {
                            setTextError('Problema al validar la sesión. Trabajando sin conexión.')
                            setTextSecondary('Reintentaremos automáticamente en segundo plano.')
                            setShowAlertSnackbar(true)
                            setTimeout(() => setShowAlertSnackbar(false), 4000)
                        } catch {}
                        globalIsAuthenticated = true
                        setIsAuthenticated(true)
                    } else {
                        // Sin usuario local, recién ahí ir al login
                        globalIsAuthenticated = false
                        try {
                            setTextError('Tu sesión no pudo validarse. Reintentá en un momento.')
                            setTextSecondary('Si persiste, inicia sesión de nuevo.')
                            setShowAlertSnackbar(true)
                            setTimeout(() => setShowAlertSnackbar(false), 4000)
                        } catch {}
                        setIsAuthenticated(false)
                        setViewLogin(true)
                    }
                } catch {
                    // En caso de error al leer DB, mantener estado actual sin forzar logout
                    globalIsAuthenticated = hasLocalLogin
                    setIsAuthenticated(hasLocalLogin)
                    if (!hasLocalLogin) setViewLogin(true)
                }
            } else {
                // Mantener estado actual y esperar reintentos sólo si hay usuario local (solo mobile). En web, siempre ir a Login si no hay sesión válida.
                if (Platform.OS !== 'web' && hasLocalLogin) {
                    globalIsAuthenticated = true
                    setIsAuthenticated(true)
                } else {
                    globalIsAuthenticated = false
                    setIsAuthenticated(false)
                    setViewLogin(true)
                }
            }
        } finally {
            if (!silent) {
                globalAuthLoading = false
                setAuthLoading(false)
            }
        }
    }

    const checkUser = async () => {
        try {
            const database = await openDB(true)
            const netInfoState = await NetInfo.fetch()
            try {
                let user = await getUser(database)
                // debug suprimido: have user?
                if (!user || (user && !user.login)) {
                    setViewLogin(true)
                } else {
                    // console.log('158 ----- si existe el user')
                    setViewLogin(false)
                }
            } catch (error) {
                console.error('🚀 ~ checkUser ~ error:getUser', error)
            }
            if (netInfoState.isConnected && netInfoState.isInternetReachable) {
                let session
                try {
                    session = await fetchAuthSession()
                } catch (error) {
                    console.error('🚀 ~ checkUser  ~ updateSession:Main1', error)
                    session = null
                }
                if (session) {
                    setViewLogin(false)
                } else {
                    setViewLogin(true)
                }
            }
        } catch (error) {
            console.error('167 --- 🚀 ~ checkUser ~ error:', error)
            setViewLogin(true)
        }
    }

    // useEffect para verificar autenticación inicial
    useEffect(() => {
        // Chequeo inicial (no silencioso) para establecer UI correctamente
        checkAmplifyAuth({ silent: false, background: false })
        const appStateListener = AppState.addEventListener('change', (state) => {
            if (state === 'active') {
                // En primer plano pero sin bloquear UI
                checkAmplifyAuth({ silent: true, background: false })
            }
        })
        // Chequeo en segundo plano cada 60s, silencioso
        const interval = setInterval(() => checkAmplifyAuth({ silent: true, background: true }), 60 * 1000)

        // Puente multiplataforma para reflejar login/logout inmediato
        // 1) Eventos nativos
        const offFns = []
        const onSignOut = () => {
            globalIsAuthenticated = false
            setIsAuthenticated(false)
            setViewLogin(true)
        }
        const onSignIn = () => {
            globalIsAuthenticated = true
            setIsAuthenticated(true)
        }
        try {
            if (eventEmitter && typeof eventEmitter.on === 'function') {
                eventEmitter.on('auth:signOut', onSignOut)
                offFns.push(() => eventEmitter.off?.('auth:signOut', onSignOut))
                eventEmitter.on('auth:signIn', onSignIn)
                offFns.push(() => eventEmitter.off?.('auth:signIn', onSignIn))
            }
        } catch {}

        // 2) Evento de storage en Web
        let storageHandler
        try {
            if (Platform.OS === 'web' && typeof window !== 'undefined') {
                storageHandler = (e) => {
                    try {
                        if (e && e.key === '__auth_event__' && e.newValue) {
                            const payload = JSON.parse(e.newValue)
                            if (payload?.type === 'signOut') onSignOut()
                            if (payload?.type === 'signIn') onSignIn()
                        }
                    } catch {}
                }
                window.addEventListener('storage', storageHandler)
            }
        } catch {}

        return () => {
            appStateListener.remove()
            clearInterval(interval)
            try { offFns.forEach((fn) => fn && fn()) } catch {}
            try { if (storageHandler && typeof window !== 'undefined') window.removeEventListener('storage', storageHandler) } catch {}
        }
    }, [])

    useEffect(() => {
    const listener = async (data) => {
            // Procesar SIEMPRE eventos del Hub, incluso sin conexión
            // debug suprimido: hub event
            const ev = data?.payload?.event
            if (
                ev === 'signIn' ||
                ev === 'signedIn' ||
                ev === 'signOut' ||
                ev === 'signedOut' ||
                ev === 'cognitoHostedUI' ||
                ev === 'tokenRefresh_failure'
            ) {
                if (ev === 'signOut' || ev === 'signedOut') {
                    // debug suprimido: logout main
                    try {
                        // Broadcast de logout
                        try { eventEmitter.emit?.('auth:signOut') } catch {}
                        try {
                            if (Platform.OS === 'web' && typeof window !== 'undefined') {
                                localStorage.setItem('__auth_event__', JSON.stringify({ type: 'signOut', ts: Date.now() }))
                            }
                        } catch {}
                        setIsAuthenticated(false)
                        setIndexTabStore(-1)
                        resetValuesStore()
                        // Limpiezas inmediatas de memoria/caché de imágenes y ratios
                        try { SizeCache.clear?.() } catch {}
                        try { Image.clearMemoryCache?.() } catch {}
                        try { Image.clearDiskCache?.() } catch {}
                        await deleteZipFolder()
                        await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.CONTINUE_DOWNLOAD, 'false')
                        await AsyncStorage.clear()
                        // Limpiar credenciales seguras/biométricas
                        try {
                            await SecureStoreWeb.deleteItemAsync('username')
                            await SecureStoreWeb.deleteItemAsync('password')
                            await SecureStoreWeb.deleteItemAsync('biometrics')
                        } catch {}
                        // Limpiar menú/footer en store (Zustand)
                        try {
                            const clearFooterApp = useFooterApp.getState?.().clearFooterApp
                            if (typeof clearFooterApp === 'function') clearFooterApp()
                        } catch {}
                        clearSplashSecondary()
                        // antes de eliminar reviso si hay algo pendiente de envio
                        try {
                            await UserServices.updateLoginStatus(false)
                            // NOTE: La verificación de pendientes y limpieza de DB ahora se hace en ProfileScreen.jsx
                            // ANTES de emitir 'auth:signOut' para evitar race condition donde checkUser 
                            // encuentra datos del usuario anterior
                            // let pendings = await UserServices.get_pendings_conections()
                            // if (pendings && pendings.status == 0) {
                            //     await UserServices.deleteAllTablesContents()
                            // }
                        } catch (error) {
                            // debug suprimido: deleteDatabase error
                        }
                        // changeValue()
                        setViewLogin(true)
                        // debug suprimido: vuelvo al login
                    } catch (error) {
                        console.error('🚀 ~ listener ~ error:', error)
                    }
                }

                if (ev === 'signIn' || ev === 'signedIn') {
                    setIsAuthenticated(true)
                    // Broadcast de login
                    try { eventEmitter.emit?.('auth:signIn') } catch {}
                    try {
                        if (Platform.OS === 'web' && typeof window !== 'undefined') {
                            localStorage.setItem('__auth_event__', JSON.stringify({ type: 'signIn', ts: Date.now() }))
                        }
                    } catch {}
                    // setViewLogin(false)
                    if (data.payload.data && data.payload.data.attributes && data.payload.data.attributes.website) {
                        setSplashSecondary(data.payload.data.attributes.website)
                    }
                    let pendings = await UserServices.get_pendings_conections()
                    // debug suprimido: signIn pendings
                    let get_user = await UserServices.getUser()
                    const user_login_sub = data.payload.data.username // user_login que llega de cognito
                    const user_login_get_user = get_user ? get_user.user_name : null // user_login que tengo en la db local

                    // debug suprimido: get_user
                    if (pendings && pendings.status == 0 && user_login_get_user === user_login_sub) {
                        console.log('🚀🚀🚀🚀🚀🚀 ~ listener ~ Elimino solo tablas de contenido porque tengo pendientes y es el mismo usuario')
                        // debug suprimido: datos para enviar
                        await UserServices.deleteAllTablesContents()
                    } else {
                        console.log('🚀🚀🚀🚀🚀🚀 ~ listener ~ Elimino toda la base de datos y la recreo porque no hay pendientes o es otro usuario')
                        await deleteDatabase()
                    }
                    const database = await openDB(true)
                    await StorageAdapter.setItem('hasLaunched', 'true')
                    await StorageAdapter.setItem('appVersion', VERSION_DATABASE.toString())
                    // debug suprimido: created tables
                    // Al autenticarse, aseguramos que el flag local quede en 1 (logged in)
                    await UserServices.updateLoginStatus(true)
                }

                if (data.payload.event == 'tokenRefresh_failure') {
                    // No forzar logout inmediato: intentar recuperar token y mantener UI si hay usuario local
                    try {
                        await getCurrentUser()
                        // Si no lanza, mantenemos sesión
                    } catch (e) {
                        try {
                            // Intento de refresh silencioso (puede reloguear con credenciales almacenadas)
                            const newToken = await getAuthToken('hub_tokenRefresh_failure')
                            if (newToken) {
                                // Token recuperado: mantenemos sesión
                                globalIsAuthenticated = true
                                setIsAuthenticated(true)
                                // Aviso corto de sesión recuperada automáticamente (1.5s)
                                try {
                                    setTextFinally('Sesión recuperada automáticamente')
                                    setShowAlertSnackbar(true)
                                    setTimeout(() => setShowAlertSnackbar(false), 1500)
                                } catch {}
                                // Revalidar en silencio más tarde
                                setTimeout(() => checkAmplifyAuth({ silent: true, background: true }), 1500)
                                return
                            }
                        } catch {}
                        // Si no hay token, comprobar usuario local para seguir en modo offline
                        try {
                            const db = await openDB(true)
                            const localUser = await getUser(db)
                            if (Platform.OS !== 'web' && localUser && localUser.login) {
                                globalIsAuthenticated = true
                                setIsAuthenticated(true)
                                // Reintentar validación en segundo plano
                                setTimeout(() => checkAmplifyAuth({ silent: true, background: true }), 2500)
                            } else {
                                // Sólo si no hay usuario local, mostrar login (sin signOut forzado)
                                setIsAuthenticated(false)
                                setViewLogin(true)
                            }
                        } catch {
                            // Si falla la DB, no derribar sesión: mantener y reintentar luego
                            globalIsAuthenticated = true
                            setIsAuthenticated(true)
                        }
                    }
                }

                if (!isVerificationPending) {
                    // debug suprimido: USS EFF 2
                    await checkAmplifyAuth()
                }
            }
        }
        const unsubscribe = Hub.listen('auth', listener)
        return () => unsubscribe()
    }, [])

    // Mostrar loader mientras verifica autenticación (evitar pasar por Login si ya está logueado)
    if (authLoading) {
        // debug suprimido: authLoading
        return (
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
                <ActivityIndicator size='large' color='#999' />
                <Text style={{ marginTop: 12, color: '#666' }}>Verificando sesión…</Text>
            </View>
        )
    }

    // debug suprimido: rendering

    // Si está autenticado en Amplify, mostrar NavigationMain independientemente de las otras variables
    if (isAuthenticated) {
        return <NavigationMain key={`main-auth-${Number(isAuthenticated)}-${Number(!authLoading)}`} />
    }

    // Si no está autenticado, mostrar Login
    return <Login key={`login-auth-${Number(isAuthenticated)}-${Number(!authLoading)}`} />
}

export default Main
